/* TinsleTime – product page: gallery, lightbox, variant picker, cart, mobile purchase bar,
   related products. No dependencies. Loaded only on product templates. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduceMotion ? 'auto' : 'smooth';

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    format = format || '€{{amount_with_comma_separator}}';
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  /* Fly a copy of the current product photo into the header cart, then run done(). */
  function flyToCart(root, done) {
    var cartIcon = document.querySelector('.tt-header__cart');
    var slides = root.querySelectorAll('[data-tt-slide] img');
    var track = root.querySelector('[data-tt-track]');
    var img = null;
    if (slides.length) {
      var idx = track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0;
      img = slides[Math.min(idx, slides.length - 1)] || slides[0];
    }
    if (reduceMotion || !cartIcon || !img || !img.animate) { done(); return; }
    var a = img.getBoundingClientRect(), b = cartIcon.getBoundingClientRect();
    if (!a.width || !b.width) { done(); return; }
    var size = Math.min(a.width, a.height, 220);
    var clone = img.cloneNode();
    clone.removeAttribute('srcset'); clone.removeAttribute('sizes'); clone.removeAttribute('loading');
    clone.className = 'tt-fly';
    clone.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;object-fit:cover;border-radius:50%;box-shadow:0 10px 30px rgba(0,0,0,.25);width:' + size + 'px;height:' + size + 'px;left:' + (a.left + a.width / 2 - size / 2) + 'px;top:' + (a.top + a.height / 2 - size / 2) + 'px;';
    document.body.appendChild(clone);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    var anim = clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 80) + 'px) scale(.55)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.08)', opacity: .4 }
    ], { duration: 850, easing: 'cubic-bezier(.5,0,.3,1)' });
    var finished = false;
    function end() { if (finished) return; finished = true; clone.remove(); cartIcon.classList.remove('is-wiggle'); void cartIcon.offsetWidth; cartIcon.classList.add('is-wiggle'); done(); }
    anim.onfinish = end;
    setTimeout(end, 1200);
  }

  function stripTags(s) { var d = document.createElement('div'); d.innerHTML = s; return d.textContent || ''; }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var gallery = root.querySelector('[data-tt-gallery]');
    if (!gallery) return null;
    var track = gallery.querySelector('[data-tt-track]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-tt-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-tt-thumb]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-tt-dot]'));
    var count = gallery.querySelector('[data-tt-count]');
    var prev = gallery.querySelector('[data-tt-prev]');
    var next = gallery.querySelector('[data-tt-next]');
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) {
        if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      if (count) count.textContent = String(i + 1);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      var thumb = thumbs[i];
      if (thumb && thumb.parentNode && thumb.parentNode.parentNode) {
        var list = thumb.parentNode.parentNode;
        var l = thumb.parentNode.offsetLeft, w = thumb.parentNode.offsetWidth;
        if (l < list.scrollLeft || l + w > list.scrollLeft + list.clientWidth) {
          list.scrollTo({ left: l - (list.clientWidth - w) / 2, behavior: behavior });
        }
      }
    }
    // Programmatic moves animate only when the gallery is on screen, and are checked
    // afterwards so the image always matches the counter, thumbnails and dots.
    var programmatic = false, settle;
    function goTo(i, instant) {
      if (i < 0 || i >= slides.length) return;
      var target = slides[i].offsetLeft - track.offsetLeft;
      var r = track.getBoundingClientRect();
      var onScreen = r.bottom > 0 && r.top < window.innerHeight;
      var smooth = !instant && onScreen && behavior === 'smooth';
      programmatic = true;
      track.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
      clearTimeout(settle);
      settle = setTimeout(function () {
        if (Math.abs(track.scrollLeft - target) > 2) track.scrollTo({ left: target, behavior: 'auto' });
        programmatic = false;
      }, smooth ? 700 : 60);
    }
    // Keep the active state in sync when the shopper swipes.
    var raf;
    track.addEventListener('scroll', function () {
      if (programmatic) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current && i >= 0 && i < slides.length) setActive(i);
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.target !== track) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(current + 1, slides.length - 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(current - 1, 0)); }
      if (e.key === 'Home') { e.preventDefault(); goTo(0); }
      if (e.key === 'End') { e.preventDefault(); goTo(slides.length - 1); }
    });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-tt-thumb'), 10)); }); });
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    setActive(0);

    // Lightbox
    var dialog = root.querySelector('[data-tt-lightbox]');
    var opener = null;
    if (dialog && typeof dialog.showModal === 'function') {
      var img = dialog.querySelector('[data-tt-lightbox-img]');
      var lbCount = dialog.querySelector('[data-tt-lightbox-count]');
      var lbIndex = 0;
      var show = function (i) {
        lbIndex = (i + slides.length) % slides.length;
        var src = slides[lbIndex].querySelector('img');
        img.src = src.getAttribute('data-full') || src.currentSrc || src.src;
        img.alt = src.alt;
        if (lbCount) lbCount.textContent = (lbIndex + 1) + ' / ' + slides.length;
      };
      var lbOpen = false;
      gallery.querySelectorAll('[data-tt-zoom]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          opener = btn;
          show(parseInt(btn.getAttribute('data-tt-zoom'), 10));
          dialog.showModal();
          lbOpen = true;
          document.documentElement.classList.add('tt-no-scroll');
        });
      });
      // Clean up straight away rather than waiting for the dialog's close event,
      // so scrolling and focus are always restored.
      var afterClose = function () {
        if (!lbOpen) return;
        lbOpen = false;
        document.documentElement.classList.remove('tt-no-scroll');
        goTo(lbIndex, true);
        var back = slides[lbIndex].querySelector('[data-tt-zoom]') || opener;
        if (back) back.focus();
      };
      var close = function () { if (dialog.open) dialog.close(); afterClose(); };
      dialog.addEventListener('close', afterClose);
      dialog.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
      dialog.querySelector('[data-tt-lightbox-close]').addEventListener('click', close);
      dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
      var lp = dialog.querySelector('[data-tt-lightbox-prev]');
      var ln = dialog.querySelector('[data-tt-lightbox-next]');
      if (lp) lp.addEventListener('click', function () { show(lbIndex - 1); });
      if (ln) ln.addEventListener('click', function () { show(lbIndex + 1); });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(lbIndex + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(lbIndex - 1); }
      });
    } else {
      // No <dialog> support: open the full image in a new tab instead.
      gallery.querySelectorAll('[data-tt-zoom]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.querySelector('img');
          window.open(src.getAttribute('data-full') || src.src, '_blank', 'noopener');
        });
      });
    }

    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        for (var k = 0; k < slides.length; k++) {
          if (String(slides[k].getAttribute('data-media-id')) === String(mediaId)) { goTo(k); return; }
        }
      }
    };
  }

  /* ---------- Variant picker + cart ---------- */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-tt-product-json]');
    var form = root.querySelector('[data-tt-product-form]');
    if (!jsonEl || !form) return;
    var data = JSON.parse(jsonEl.textContent);
    var T = data.i18n || {};
    var variants = data.variants;
    var gallery = initGallery(root);
    var idInput = form.querySelector('[data-tt-variant-id]');
    var addBtn = form.querySelector('[data-tt-add]');
    var addLabel = addBtn.querySelector('[data-tt-add-label]');
    var priceEl = root.querySelector('[data-tt-price]');
    var msgEl = root.querySelector('[data-tt-msg]');
    var statusEl = root.querySelector('[data-tt-status]');
    var errorEl = root.querySelector('[data-tt-error]');
    var express = root.querySelector('[data-tt-express]');
    var barBtn = root.querySelector('[data-tt-bar-add]');
    var barPrice = root.querySelector('[data-tt-bar-price]');
    var fieldsets = Array.prototype.slice.call(form.querySelectorAll('[data-tt-option]'));
    var hiddenOpts = Array.prototype.slice.call(form.querySelectorAll('[data-tt-option-hidden]'));
    var optionCount = fieldsets.length + hiddenOpts.length;
    var contactUrl = (msgEl && msgEl.getAttribute('data-contact')) || '/pages/contact';

    function blocked(v) { return !!(data.blockZero && v && v.price === 0); }
    function buyable(v) { return !!(v && v.available && !blocked(v)); }

    function selectedOptions() {
      var sel = [];
      fieldsets.forEach(function (fs) {
        var i = parseInt(fs.getAttribute('data-tt-option'), 10);
        var checked = fs.querySelector('input:checked');
        sel[i] = checked ? checked.value : null;
      });
      hiddenOpts.forEach(function (h) { sel[parseInt(h.getAttribute('data-tt-option-hidden'), 10)] = h.value; });
      return sel;
    }
    function findVariant(sel) {
      for (var k = 0; k < variants.length; k++) {
        var v = variants[k], ok = true;
        for (var j = 0; j < optionCount; j++) { if (v.options[j] !== sel[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    // Mark option values that cannot be bought together with the other current choices.
    function markAvailability(sel) {
      fieldsets.forEach(function (fs) {
        var i = parseInt(fs.getAttribute('data-tt-option'), 10);
        fs.querySelectorAll('input[type=radio]').forEach(function (input) {
          var test = sel.slice(); test[i] = input.value;
          var v = findVariant(test);
          var ok = buyable(v);
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (!label) return;
          label.classList.toggle('is-unavailable', !ok);
          var note = label.querySelector('[data-tt-unavailable-note]');
          if (note) note.textContent = ok ? '' : (note.getAttribute('data-suffix') || ', unavailable');
        });
        var checked = fs.querySelector('input:checked');
        var out = fs.querySelector('[data-tt-option-value]');
        if (out && checked) out.textContent = checked.value;
      });
    }

    function setButtons(v) {
      var label;
      if (!v) label = addBtn.getAttribute('data-label-unavailable');
      else if (blocked(v)) label = addBtn.getAttribute('data-label-unavailable');
      else if (!v.available) label = addBtn.getAttribute('data-label-soldout');
      else label = addBtn.getAttribute('data-label-add');
      var can = buyable(v);
      addBtn.disabled = !can;
      addLabel.textContent = label;
      if (barBtn) { barBtn.disabled = !can; barBtn.textContent = label; }
      if (express) express.hidden = !can;
    }

    function renderPrice(v) {
      if (!priceEl) return;
      if (!v || blocked(v)) {
        priceEl.innerHTML = '<span class="tt-buy__price-now">' + esc(T.priceUnavailable || 'Price unavailable') + '</span>';
        if (barPrice) barPrice.textContent = '';
        return;
      }
      var html = '<span class="tt-visually-hidden">' + esc(T.price || 'Price') + '</span>';
      var sale = v.compare_at_price > v.price;
      html += '<span class="tt-buy__price-now' + (sale ? ' is-sale' : '') + '">' + formatMoney(v.price, data.moneyFormat) + '</span>';
      if (sale) {
        html += '<span class="tt-visually-hidden">' + esc(T.regularPrice || 'Regular price') + '</span><s class="tt-buy__price-was">' + formatMoney(v.compare_at_price, data.moneyFormat) + '</s>';
        html += '<span class="tt-buy__save">' + (T.save || 'Save {amount}').replace('{amount}', formatMoney(v.compare_at_price - v.price, data.moneyFormat)) + '</span>';
      }
      priceEl.innerHTML = html;
      if (barPrice) barPrice.textContent = stripTags(formatMoney(v.price, data.moneyFormat));
    }

    function renderMessage(v) {
      if (!msgEl) return;
      if (!v) {
        msgEl.textContent = T.combo || 'This combination isn’t available. Please choose another option.';
        msgEl.hidden = false;
      } else if (blocked(v)) {
        msgEl.innerHTML = T.blocked || ('This option can’t be ordered online right now. <a href="' + contactUrl + '">Contact us</a> about availability.');
        msgEl.hidden = false;
      } else if (!v.available) {
        msgEl.textContent = T.soldOut || 'This option is sold out.';
        msgEl.hidden = false;
      } else {
        msgEl.textContent = '';
        msgEl.hidden = true;
      }
    }

    // Progress towards free delivery: real threshold, real cart total.
    var freeEl = root.querySelector('[data-tt-free]');
    var cartTotal = 0, afterAdd = false;
    function renderFree(v) {
      if (!freeEl) return;
      var threshold = parseInt(freeEl.getAttribute('data-threshold'), 10) || 0;
      if (!threshold || !v || !buyable(v)) { freeEl.hidden = true; return; }
      var qtyEl = form.querySelector('.tt-qty__input');
      var q = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
      // Before adding: show what the order would be with this item. After adding: the cart as it is.
      var total = afterAdd ? cartTotal : cartTotal + v.price * q;
      var left = threshold - total;
      var text = freeEl.querySelector('[data-tt-free-text]');
      var fill = freeEl.querySelector('[data-tt-free-fill]');
      if (left > 0) {
        text.innerHTML = esc(freeEl.getAttribute('data-label-left')).replace('{amount}', '<strong>' + formatMoney(left, data.moneyFormat) + '</strong>');
        freeEl.classList.remove('is-ok');
      } else {
        text.textContent = freeEl.getAttribute('data-label-ok');
        freeEl.classList.add('is-ok');
      }
      fill.style.width = Math.min(100, Math.round(total / threshold * 100)) + '%';
      freeEl.hidden = false;
    }
    function loadCartTotal() {
      var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return fetch(r + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (x) { return x.json(); })
        .then(function (c) { cartTotal = c.total_price || 0; renderFree(findVariant(selectedOptions())); }).catch(function () {});
    }
    loadCartTotal();

    function update(fromUser) {
      var sel = selectedOptions();
      var v = findVariant(sel);
      if (v) idInput.value = v.id;
      setButtons(v);
      renderPrice(v);
      renderMessage(v);
      if (fromUser) afterAdd = false;
      renderFree(v);
      markAvailability(sel);
      if (errorEl) errorEl.textContent = '';
      if (fromUser && v) {
        if (v.media_id && gallery) gallery.showMedia(v.media_id);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url.toString());
        } catch (e) { /* ignore */ }
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); }); });
    update(false);

    // Quantity stepper
    var qty = form.querySelector('.tt-qty__input');
    form.querySelectorAll('[data-tt-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-tt-qty'), 10);
        qty.value = Math.max(1, Math.min(99, n));
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    if (qty) qty.addEventListener('change', function () {
      var n = parseInt(qty.value, 10);
      if (!n || n < 1) qty.value = 1;
      if (n > 99) qty.value = 99;
      afterAdd = false;
      renderFree(findVariant(selectedOptions()));
    });

    // Add to cart without leaving the page
    var busy = false, resetTimer;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = findVariant(selectedOptions());
      if (busy || !buyable(v)) return;
      busy = true;
      clearTimeout(resetTimer);
      addBtn.setAttribute('aria-busy', 'true');
      addBtn.classList.add('is-loading');
      addLabel.textContent = addBtn.getAttribute('data-label-adding');
      if (barBtn) { barBtn.setAttribute('aria-busy', 'true'); barBtn.textContent = addBtn.getAttribute('data-label-adding'); }
      if (errorEl) errorEl.textContent = '';
      if (statusEl) statusEl.textContent = '';
      var quantity = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
      var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: quantity }] })
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body && (res.body.description || res.body.message) || (T.error || 'Something went wrong. Please try again.'));
          return fetch(root_url + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          flyToCart(root, function () {
            document.querySelectorAll('[data-tt-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.toggle('is-empty', cart.item_count === 0);
              el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
            });
          });
          cartTotal = cart.total_price || 0;
          afterAdd = true;
          renderFree(findVariant(selectedOptions()));
          var title = root.querySelector('.tt-buy__title').textContent.trim();
          var variantName = (v.title && v.title !== 'Default Title') ? ' (' + v.title + ')' : '';
          addLabel.textContent = addBtn.getAttribute('data-label-added');
          addBtn.classList.add('is-added');
          addBtn.classList.remove('is-pop'); void addBtn.offsetWidth; addBtn.classList.add('is-pop');
          if (barBtn) barBtn.textContent = addBtn.getAttribute('data-label-added');
          if (statusEl) {
            statusEl.innerHTML = '';
            var p = document.createElement('p');
            p.className = 'tt-buy__added';
            p.textContent = (T.addedStatus || '{qty} × {title} added to your cart.').replace('{qty}', quantity).replace('{title}', title + variantName) + ' ';
            var a = document.createElement('a');
            a.href = root_url + 'cart';
            a.textContent = T.viewCart || 'View cart';
            p.appendChild(a);
            statusEl.appendChild(p);
          }
          resetTimer = setTimeout(function () { addBtn.classList.remove('is-added'); setButtons(findVariant(selectedOptions())); }, 2600);
        })
        .catch(function (err) {
          if (errorEl) errorEl.textContent = err.message || (T.error || 'Something went wrong. Please try again.');
          setButtons(findVariant(selectedOptions()));
        })
        .then(function () {
          busy = false;
          addBtn.removeAttribute('aria-busy');
          addBtn.classList.remove('is-loading');
          if (barBtn) barBtn.removeAttribute('aria-busy');
        });
    });

    initStickyPanel(root);
    initBuyBar(root, addBtn);
  }

  /* Desktop: keep the buying panel in view while browsing the gallery, but only when it fits. */
  function initStickyPanel(root) {
    var info = root.querySelector('[data-tt-info]');
    if (!info) return;
    function check() {
      var fits = window.innerWidth >= 990 && info.firstElementChild.offsetHeight + 48 <= window.innerHeight;
      info.classList.toggle('is-sticky', fits);
    }
    check();
    window.addEventListener('resize', check);
    if ('ResizeObserver' in window) new ResizeObserver(check).observe(info.firstElementChild);
  }

  /* Mobile: a slim purchase bar while the main button is off screen. */
  function initBuyBar(root, addBtn) {
    var bar = root.querySelector('[data-tt-buybar]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var mainVisible = true, footerVisible = false;
    var mq = window.matchMedia('(max-width: 989px) and (min-height: 480px)');
    // Never cover Shopify's cookie banner (it is position: fixed, so check its boxes).
    function consentShowing() {
      var els = document.querySelectorAll('#shopify-pc__banner, .shopify-pc__banner__dialog');
      for (var k = 0; k < els.length; k++) {
        var cs = window.getComputedStyle(els[k]);
        if (els[k].getClientRects().length && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0) return true;
      }
      return false;
    }
    function render() {
      var show = mq.matches && !mainVisible && !footerVisible && !consentShowing();
      bar.hidden = !show;
      document.documentElement.classList.toggle('tt-has-buybar', show);
    }
    new IntersectionObserver(function (entries) { mainVisible = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; render(); }).observe(addBtn);
    var footer = document.querySelector('.tt-footer');
    if (footer) new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; render(); }).observe(footer);
    if (mq.addEventListener) mq.addEventListener('change', render);
    setInterval(render, 2000); // re-check if a consent banner appears or closes
  }

  /* Related products */
  function initRecommendations() {
    document.querySelectorAll('[data-tt-recs]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.__ttLoaded) return;
      el.__ttLoaded = true;
      fetch(url).then(function (r) { return r.text(); }).then(function (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var fresh = tmp.querySelector('[data-tt-recs]');
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      }).catch(function () { /* leave empty */ });
    });
  }

  function init() {
    document.querySelectorAll('[data-tt-pdp]').forEach(initProduct);
    initRecommendations();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-tt-pdp]').forEach(initProduct);
    initRecommendations();
  });
})();
